import { useEffect, useRef, MutableRefObject } from "react";
import { handleEvent } from "../components/track/util";

type Options = {
  threshold: number;
};

export const useElementVisibility = <T extends HTMLElement>({
  data,
  options = { threshold: 1 },
}: {
  data: {
    name: string;
    properties: {
      category: string;
      handle?: string;
    };
  };
  options?: Options;
}): [MutableRefObject<T | null>] => {
  const elementRef = useRef<T | null>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        handleEvent(data);
      }
    }, options);

    if (elementRef.current) {
      observerRef.current.observe(elementRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [options.threshold]);

  return [elementRef];
};
